import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_menu_top",
  "use": "rt-portal-rt_menu_top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-rt_menu_top\">\r\n<path d=\"M199.4,736.6l292.8-230.9c11.6-9.2,28-9.2,39.6,0l292.8,230.9c2.8,2.2,6.3,3.4,9.9,3.4h101.5c7.6,0,11-9.7,5-14.5L531.8,403\r\n\tc-11.6-9.2-28-9.2-39.7,0l-409,322.5c-6,4.7-2.7,14.5,5,14.5h101.5C193.1,740,196.6,738.8,199.4,736.6z\" />\r\n<path d=\"M899.9,316H124c-6.6,0-12-5.4-12-12v-44c0-8.8,7.2-16,16-16h771.9c6.6,0,12,5.4,12,12v48C911.9,310.6,906.5,316,899.9,316z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_menu_top.svg
// module id = 1875
// module chunks = 137